const ActionType = {
  REQUEST: "MASTER_DATA_REQUEST",
  REQUEST_FINISHED: "MASTER_DATA_REQUEST_FINISHED",
};

export default ActionType;
